import { render, staticRenderFns } from "./aufgaben_table_abgelehnt.vue?vue&type=template&id=220de4d0&scoped=true"
import script from "./aufgaben_table_abgelehnt.vue?vue&type=script&lang=js"
export * from "./aufgaben_table_abgelehnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220de4d0",
  null
  
)

export default component.exports